export const commonMinWidthFunction = (showYield, showDates, showDuration, selectedTaka) => {

  const getMinWidthForTakaVersion = () => {
    switch (selectedTaka) {
      case "Taka 4.1 a":
        return "3200px";
      case "Taka 4.1 c":
        return "3030px";
      default:
        return "2910px";
    }
  }

  if (showYield && !showDates && !showDuration && selectedTaka === "Taka 4.1 a") {
    return "1930px";
  }
  if (!showYield && (!showDates || !showDuration)) {
    return "100%";
  }

  if (showYield && !showDates && !showDuration) {
    return "100%";
  }

  if (!showYield && showDates && showDuration) {
    return "1935px";
  }


  return getMinWidthForTakaVersion();
};
